var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.label,"color":"#000080","solo":"","error-messages":_vm.errorMessages},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }